import styled from 'styled-components';

export const GithubCardBox = styled.div`
  position: relative;

  background: ${props => props.theme.bg};
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1), 0 0px 0px 0 rgba(0, 0, 0, 0.0);
`;
